import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "@config/config";
import { AuthContext } from "@context/AuthContext";

export const SessionContext = createContext({});

const SessionContextProvider = (props) => {
    const { isLoggedIn } = useContext(AuthContext);
    const [isLoadingSession, setIsLoadingSession] = useState(false);
    const [session, setSession] = useState(null);
    const [purchasable, setPurchasable] = useState(null);
    const [candyBarInventory, setCandyBarInventory] = useState(null);
    const [hasCandyBarInventory, setHasCandyBarInventory] = useState(null);
    const { children } = props;

    const fetchPurchasable = (id) => {
        setIsLoadingSession(true);

        axios
            .get(`${API_BASE_URL}/purchasable/${id}?limit=1`)
            .then(function(response) {
                if (response.data.successUrl) {
                    window.open(response.data.data, "_self");
                }
                setIsLoadingSession(false);
                const sessionData = response.data.data.sessions.map((item) => {
                    return {
                        ...item,
                        cinema_group_id: item.cinema_group_id,
                        ticket_price_cents: parseInt(item.ticket_price_cents),
                        rrp_pricing_cents: item.rrp_pricing_cents,
                    };
                });
                const candyBarInventory = response.data.data.candybar.map(
                    (item) => {
                        return {
                            ...item,
                            candy_bar_price: parseInt(item.candy_bar_price),
                            candy_bar_rrp_price: parseInt(item.candy_bar_rrp_price),
                            rebate_cents: parseInt(item.rebate_cents),
                        };
                    },
                );
                setPurchasable([...sessionData, ...candyBarInventory]);
                setHasCandyBarInventory(candyBarInventory);
                setSession(sessionData[0]);
                setIsLoadingSession(false);
            })
            .catch(({ response }) => {
                setIsLoadingSession(false);
                setSession(null);
                setPurchasable(null);
                console.log(response);
                if (isLoggedIn && response?.status === 401) {
                    window.location = "/";
                }
            });
    };

    return (
        <SessionContext.Provider
            value={{
                fetchPurchasable,
                isLoadingSession,
                setIsLoadingSession,
                candyBarInventory,
                setCandyBarInventory,
                session,
                purchasable,
                setSession,
                setPurchasable,
                hasCandyBarInventory,
            }}
        >
            {children}
        </SessionContext.Provider>
    );
};

export default SessionContextProvider;
